module.exports = __webpack_public_path__ + "static/img/video.acc9355b.png";